import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box } from '@design-system/box';
import { Button } from '@design-system/button';
import { Dotdotdot } from '@design-system/dotdotdot';
import { s__ } from '@design-system/i18n';
import { DefaultLink } from '@design-system/link';
import { MediaWrapper } from './MediaWrapper';
import { ConsentStorage } from '../ConsentStorage';
export const ConsentGuard = ({ aspectRatio, children, hostName, isActive, providerName, }) => {
    var _a;
    const consent = hostName ? ConsentStorage.isProviderAllowed(hostName) : false;
    const [isShown, setIsShown] = useState(consent);
    const handleShowOnce = () => setIsShown(true);
    const handleShowAlways = () => {
        if (hostName) {
            ConsentStorage.setProvider(hostName, providerName);
        }
        setIsShown(true);
    };
    if (isShown || !isActive) {
        return children;
    }
    return (_jsx(MediaWrapper, { "$aspectRatio": aspectRatio, flexDirection: "column", overflow: "auto", px: 4, py: 5, children: _jsxs(Box, { flexDirection: "column", my: "auto", children: [_jsxs(Box, { flexDirection: "column", children: [_jsx(Box, { font: "h4-semibold", mb: 2, pr: 10, children: s__('Embed|Show third-party media?') }), _jsx(Box, { children: s__('Embed|This media may use cookies and has its own privacy policy. You always can change your choice in privacy settings of your account.') }), _jsxs(Box, { flexWrap: "wrap", mt: 4, children: [_jsx(Button, { mb: 1, mr: 1, onClick: handleShowAlways, size: "small", variant: "primary", children: s__('Embed|Always for %{providerName}').i__({
                                        providerName: (_a = providerName !== null && providerName !== void 0 ? providerName : hostName) !== null && _a !== void 0 ? _a : '',
                                    }) }), _jsx(Button, { mb: 1, onClick: handleShowOnce, size: "small", variant: "secondary", children: s__('Embed|Allow once') })] })] }), Boolean(hostName) && (_jsx(Box, { mt: 4, children: _jsx(Dotdotdot, { clamp: 1, children: _jsx(DefaultLink, { font: "metadata-regular-dove", href: hostName, styledOnlyOnHover: true, target: "_blank", children: hostName }) }) }))] }) }));
};
//# sourceMappingURL=ConsentGuard.js.map